

document.addEventListener('DOMContentLoaded', () => {
    const $toggleBtn = $('#toggleTimeline');
    const $timelineItems = $('.progress-timeline li:not(:last-child)');


    $toggleBtn.on('click', function(e) {
        e.preventDefault();

        const isExpanded = $(this).data('expanded') === true;

        $(this)
            .html(isExpanded ? '<i class="fa-solid fa-plus"></i> View Timeline' : '<i class="fa-solid fa-minus"></i> Hide Timeline')
            .data('expanded', !isExpanded);

        if (!isExpanded) {
            $timelineItems.stop().slideDown('slow').addClass('is-visible');
        } else {
            $timelineItems.stop().slideUp('slow').removeClass('is-visible');
        }
    });
});

